const AboutData = {
  image: require("../assets/Images/about.png"),
  description: [
    "A passionate and dedicated web developer with a strong background in creating visually stunning and highly functional websites in the field.",
    "Throughout my career, I have developed proficiency in various web technologies including HTML5 , CSS3 , JavaScript. I am well-versed in popular libraries such as React and frameworks like Next ,Tailwind allowing me to build robust and responsive websites.",
    "I'm excited to take on new challenges and contribute to innovative projects. Feel free to connect with me through my social media link",
  ],
};
export default AboutData;
